<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <!-- visitor_schedule_list:-{{ visitor_schedule_list }} <br /> -->
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Schedule Visit </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense ref="selectedCard">
        <v-col cols="12" sm="2" md="2"></v-col>
        <v-col cols="12" sm="8" md="8">
          <p><v-icon color="error">*</v-icon><b>Visit Purpose</b></p>
          <v-textarea auto-grow outlined name="input-7-4" v-model.trim="purpose"
            label="Enter Purpose of visit"></v-textarea>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>

        <v-col cols="12" sm="4" md="4">
          <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="From Date"
            v-model="from_date_time"></v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="To Date"
            v-model="to_date_time"></v-datetime-picker>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>

        <v-col cols="12" sm="4" md="4" v-if="checkbox1 == false">
          <p><v-icon color="error">*</v-icon><b>Whom To Contact</b></p>
          <v-autocomplete color="#0F2027" dense rounded :items="host" item-text="inst_name" item-value="id"
            label="Select Host" outlined persistent-hint hint="Please Select Host" v-model="host_id" />
          <!-- {{ host_id }} -->
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p><b>Vehicle Number</b></p>
          <v-text-field outlined dense type="text" rounded persistent-hint hint="Please Enter Vehicle Number"
            v-model="vehicle_number"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>

        <v-col cols="12" sm="4" md="4">
          <v-checkbox v-model="checkbox1" label="Host Not in List"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="checkbox1 == true">
          <v-text-field outlined dense type="text" v-model="whomtocontact"></v-text-field>
        </v-col>
      </v-row>

      <br />
      <!-- host:{{host}} -->
      <v-row justify="center" dense>
        <v-btn class="button" :disabled="isSaveButtonDisabled" @click="addScheduleVisit">Schedule Visit
        </v-btn>
      </v-row>
    </v-card>
    <!-- table view -->
    <v-card class="box">
      <!-- <template v-slot:top> -->
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Visitor List </strong>
        </v-toolbar-title>
      </v-toolbar>
      <!-- </template> -->
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="visitor_schedule_list" :search="search" class="mytable1">
        <template v-slot:[`item.people`]="{ item }">
          <div>
            {{ item.visitors_cnt }}
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="
                addPeople(item);
              dialog_add_new = true;
              " title="Add People">add</v-icon>
            </v-avatar>
          </div>
        </template>
        `
        <template v-slot:[`item.action`]="{ item }">
          <div>
            <!-- <v-avatar size="25" class="edit-avatar">
              <v-icon
                class="mr-2 edit-v-icon"
                @click="editItem(item)"
                title="edit"
                >edit</v-icon
              >
            </v-avatar> -->
            <v-avatar size="35">
              <v-icon v-if="item.visitors_cnt == 0" class="mr-4 v-icon-size" color="red" title="delete"
                @click="deleteVS(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>`
      </v-data-table>
    </v-card>
    <!-- dialog box code -->
    <v-dialog v-if="add_people_data != null" v-model="dialog_add_new" persistent fullscreen hide-overlay
      transition="dialog-bottom-transition">
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-btn icon dark @click="dialog_add_new = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Visitor</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="dialog_add_new = false"> Save </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <!-- {{add_people_data.vs_id}} -->
        <v-row dense>
          <v-col cols="12" sm="1" md="2"></v-col>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Visit Purpose</b></p>

            <v-text-field outlined dense type="text" v-model="add_people_data.vs_purpose" readonly
              filled></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>To Whom Contact</b></p>

            <v-text-field outlined dense type="text" v-model="add_people_data.vs_whom_to" readonly
              filled></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="1" md="2"></v-col>

          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>From Date and Time</b></p>

            <v-text-field outlined dense type="text" v-model="add_people_data.vs_from_date_time" readonly
              filled></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>To Date and Time</b></p>

            <v-text-field outlined dense type="text" v-model="add_people_data.vs_to_date_time" readonly
              filled></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_visitor" :items="visitors_list"
              item-text="visitor_mob_name" return-object label="Search visitors by mobile no And Name" clearable
              outlined />
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-btn class="button" @click="addVisitor()">Add Visitor</v-btn>
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="2" md="2" style="margin-top: -7px;">
            <v-checkbox v-model="visitor_not_in_list" label="Visitor Not In List"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <!-- <v-btn class="button" @click="addVisitor"
              ><v-icon>mdi-account-plus</v-icon></v-btn
            > -->
            <v-tooltip top v-if="visitor_not_in_list">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="button" v-bind="attrs" v-on="on" @click="addNewVisitor">
                  <v-icon>mdi-account-plus</v-icon></v-btn>
              </template>
              <span> Add Visitor </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-checkbox v-model="edit_flag" label="Edit schedule"></v-checkbox>
        <template v-if="edit_flag">
          <!-- ////////////////////////////////////////////////////////// -->
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong>
                  Edit Schedule Visit [Enter only data that needs to be
                  edited]</strong>
              </v-toolbar-title>
            </v-toolbar>
            <v-row dense ref="selectedCard">
              <v-col cols="12" sm="2" md="2"></v-col>
              <v-col cols="12" sm="8" md="8">
                <p><v-icon color="error">*</v-icon><b>Visit Purpose</b></p>
                <v-textarea auto-grow outlined name="input-7-4" v-model.trim="purpose"
                  label="Enter New Purpose of visit. (if any changes)"></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="2"></v-col>

              <v-col cols="12" sm="4" md="4">
                <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa"
                  label="Select new From Date. (if any changes)" v-model="from_date_time"></v-datetime-picker>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa"
                  label="Select new To Date. (if any changes)" v-model="to_date_time"></v-datetime-picker>
              </v-col>
            </v-row>


            <br />
            <!-- host:{{host}} -->
            <v-row justify="center" dense>
              <v-btn class="button" @click="editScheduleVisit(add_people_data.vs_id, add_people_data.visitor_id)">Edit
                Schedule
                Visit
              </v-btn>
            </v-row>
          </v-card>
          <!-- /////////////////////////////////////////////////////////////// -->
        </template>
        <!-- table of visitors -->
        <v-card class="box">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Visitor List </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-data-table :headers="headers1" :items="added_visitors_list" :search="search" class="mytable1">
            <template v-slot:[`item.action`]="{ item }">
              <div>
                <v-avatar size="35">
                  <v-icon class="mr-4 v-icon-size" color="red" title="delete"
                    @click="deleteVisitor(item)">mdi-trash-can</v-icon>
                </v-avatar>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import DatetimePicker from "vuetify-datetime-picker";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    extraBreadcrumbItems: [
      

    ],
    breadcrumbClass: "breadcrumb-style1",
    ///////////////////////////////////////////////
    checkbox1: false,
    host: [],
    visitor_schedule_list: [],
    ////////////
    from_date_time: null,
    to_date_time: null,
    purpose: "",
    whomtocontact: "",
    vehicle_number: "",
    host_id: null,
    search: "",
    drpdwn_whomtocontact: "",
    dialog_add_new: false,
    vs_id: "",
    added_visitors_list: [],
    sel_visitor: "",
    visitor_id: "",
    visitors_list: [],
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Purpose", value: "vs_purpose" },
      { text: "From Date and Time", value: "vs_from_date_time" },
      { text: "To Date and Time", value: "vs_to_date_time" },
      // { text: "Visit Type", value: "" },
      { text: "Whom to Contact", value: "vs_whom_to" },
      { text: "Vehicle Number", value: "vehicle_number" },
      { text: "People", value: "people" },
      //   { text: "People12", value: "visitors_cnt" },

      { text: "Action", value: "action" },
    ],
    headers1: [
      { text: "Sr. No", value: "srno" },
      { text: "Mobile", value: "visitor_mobile" },
      { text: "Name", value: "visitor_name" },
      { text: "Email", value: "visitor_email" },
      { text: "Address", value: "visitor_address" },
      // { text: "Entry Date", value: "" },
      { text: "Action", value: "action" },
    ],
    /////////////////////////
    add_people_data: null,
    edit_flag: false,
    visitor_not_in_list: false,
  }),
  mounted() {
    this.onLoad();
  },

  computed: {
    isSaveButtonDisabled() {
      return !(this.purpose && this.from_date_time && this.to_date_time);
    },
  },
  methods: {
    addNewVisitor() {
      //this.$router.push({ name: "admin-add-visitor", target: "_blank" });
      let routeData = this.$router.resolve({ name: "admin-add-visitor" });
      window.open(routeData.href, "_blank");
      this.dialog_add_new = false;
    },
    reset() {
      // this.save_edit = "Save";
      this.from_date_time = "";
      this.to_date_time = "";
      this.purpose = "";
      this.whomtocontact = "";
      this.vehicle_number = "";
      this.host_id = "";
      this.sel_visitor = "";
      this.edit_flag = false;
      this.visitor_not_in_list = false;
      // this.handover_instructor = "";
      // this.description = "";
      // this.address = "";
    },
    addPeople(item) {
      console.log("add people", item);
      // this.whomtocontact = item.vs_whom_to;
      // this.purpose = item.vs_purpose;
      // this.from_date_time = item.vs_from_date_time;
      // this.to_date_time = item.vs_to_date_time;
      //   this.from_date_time = this.formatDate(this.from_date_time, true);
      this.visitor_not_in_list = false;
      this.add_people_data = item;
      const formdata = {
        vs_id: item.vs_id,
      };
      axios
        .post("/visitorManagement/getScheduleVisitPerson", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitors_list = res.data.visitors_list;
            this.added_visitors_list = res.data.added_visitors;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    deleteVisitor(item) {
      if (!confirm("Visitor E-pass Send to Mail/WhatApp.. Are You Sure You Want To Delete this ?")) return;
      const formdata = {
        visitor_id: item.visitor_id,
        vs_id: this.add_people_data.vs_id,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/deleteScheduleVisitPerson", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.visitors_list = res.data.visitors_list;
            // this.showSnackbar("green", res.data.snackbar);
            this.showSnackbar("green", "Visitor delete Succesfully!!");
            this.reset();
            this.onLoad();
            this.dialog_add_new = false; // close dialog box
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    deleteVS(item) {

      console.log("deleteVS:", item);
      const formdata = {
        vs_id: item.vs_id,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/deleteScheduleVisit", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.visitors_list = res.data.visitors_list;
            // this.showSnackbar("green", res.data.snackbar);
            this.showSnackbar("green", "Visitor delete Succesfully!!");
            this.reset();
            this.onLoad();
            this.dialog_add_new = false; // close dialog box
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    addVisitor() {
      // alert("in add visitor");
      //   console.log("in add visitor", this.sel_visitor.visitor_id);
      // this.dialog_add_new = false; // close dialog box

      // this.add_people_data.visitors_cnt = this.add_people_data.visitors_cnt++;
      if (this.sel_visitor == null || this.sel_visitor == "") {
        this.showSnackbar("red", " Please  Select Visitor...!!");
        return;
      }
      console.log(" sel visitor", this.sel_visitor);
      const formdata = {
        vs_purpose: this.add_people_data.vs_purpose,
        vs_whom_to: this.add_people_data.vs_whom_to,
        visitor_id: this.sel_visitor.visitor_id,
        vs_id: this.add_people_data.vs_id,
      };

      axios
        .post("/visitorManagement/addScheduleVisitPerson", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.visitors_list = res.data.visitors_list;
            this.added_visitors_list = res.data.added_visitors;
            // this.showSnackbar("green", res.data.snackbar);
            this.showSnackbar("green", "Visitor added Succesfully!!");
            this.sendtomail();

            this.reset();
            this.onLoad();
            this.dialog_add_new = false; // close dialog box
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;

        });
    },
    sendtomail() {
      const formdata = {
        vs_id: this.add_people_data.vs_id,
      };

      if (this.sel_visitor && this.sel_visitor.visitor_id) {
        formdata.visitor_id = this.sel_visitor.visitor_id;
      } else {
        formdata.visitor_id = this.add_people_data.visitor_id;
      }

      this.overlay = true;

      axios
        .post("/visitorManagement/sendmailtovisitor", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },



    editItem(item) {
      this.$vuetify.goTo(this.$refs.selectedCard); // for scrolling up

      //   this.save_edit = "Edit";
      this.purpose = item.vs_purpose;
      this.whomtocontact = item.vs_whom_to;
      this.vehicle_number = item.vehicle_number;
      this.from_date_time = item.vs_from_date_time;
      this.to_date_time = item.vs_to_date_time;
      console.log("date", this.from_date_time);

    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ////////////////////
    onLoad() {
      this.overlay = true;
      axios
        .post("/visitorManagement/scheduleVisit")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitor_schedule_list = res.data.visitor_schedule_list;
            this.host = res.data.host;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() + 1
        }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    addScheduleVisit() {
      let form_from_date_time = this.formatDate(this.from_date_time, true);
      let form_to_date_time = this.formatDate(this.to_date_time, true);
      const formdata = {
        from_date_time: form_from_date_time,
        to_date_time: form_to_date_time,
        host_id: this.host_id,
        purpose: this.purpose,
        whomtocontact: this.whomtocontact,
        vehicle_number: this.vehicle_number,
        // inst_name: this.drpdwn_whomtocontact,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/addScheduleVisit", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            this.reset();
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    editScheduleVisit(vs_id, visitor_id) {
      let form_from_date_time = null;
      let form_to_date_time = null;
      console.log(this.from_date_time);
      if (this.from_date_time != null && this.from_date_time != "")
        form_from_date_time = this.formatDate(this.from_date_time, true);
      if (this.to_date_time != null && this.to_date_time != "")
        form_to_date_time = this.formatDate(this.to_date_time, true);
      const formdata = {
        vs_id: vs_id,
        from_date_time: form_from_date_time,
        to_date_time: form_to_date_time,
        purpose: this.purpose,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/editScheduleVisit", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            if (Array.isArray(visitor_id) && visitor_id.length > 0) {
              console.log("Visitor ID is an array and has elements: ", visitor_id);

              this.sendtomail();
            } else {
              console.log("Visitor ID is not an array or is empty");
            }
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            this.dialog_add_new = false;

            this.reset();
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style></style>